import React, {useState} from 'react';
import {useSessionStore} from '../../hooks/useSessionStore';
import {UsuarioContext} from '../../contexts/UsuarioContext';
import {MenuLateralAB} from '../menuLateralAA/MenuLateralAB';

import {PopupWidget} from 'react-calendly';
import {useCalendlyEventListener, InlineWidget} from 'react-calendly';
import {PopupButton} from 'react-calendly';

export const ContentBodyCalendario = () => {
	/* Using the useSessionStore hook to get the UsuarioContext from the session storage. */
	const [Usuario, setUsuario] = useSessionStore(UsuarioContext);

	useCalendlyEventListener({
		onProfilePageViewed: () => console.log('onProfilePageViewed'),
		onDateAndTimeSelected: () => console.log('onDateAndTimeSelected'),
		onEventTypeViewed: () => console.log('onEventTypeViewed'),
		onEventScheduled: (e) => console.log(e.data.payload),
	});

	return (
		<div className='ContentUserFeedback'>
			<MenuLateralAB seleccionado={6} />
			<div className='derContentMiEmpresa'>
				<div>
					<div className='App'>
						<InlineWidget url='https://calendly.com/roberto-hermoso' />
					</div>
				</div>
			</div>
		</div>
	);
};
